import i18next from 'i18next'

import type {
  WidgetTranslationKey,
  WidgetTranslations,
} from '#src/i18n/types.ts'

export type CookieConsentTranslator = (
  key: WidgetTranslationKey,
  options?: Record<string, string | number>,
) => string

export function createI18nTranslator({
  translations,
  locale,
  defaultLocale,
}: {
  translations: WidgetTranslations
  locale: string
  defaultLocale: string
}): CookieConsentTranslator {
  const resolvedLocale = locale ?? defaultLocale
  const i18n = i18next.createInstance()

  i18n.init({
    resources: {
      [resolvedLocale]: {
        translation: translations,
      },
    },
    lng: locale,
    fallbackLng: defaultLocale,
    returnEmptyString: false,
    returnNull: false,
    initImmediate: false,
    interpolation: {
      escapeValue: false,
    },
  })

  return (key, options) => {
    const translated = i18n.t(key, options)

    if (!options || !translated.includes('{{')) {
      return translated
    }

    return translated.replace(/\{\{(\w+)\}\}/g, (_match, variableName) => {
      const value = options[variableName]
      return value === undefined ? `{{${variableName}}}` : String(value)
    })
  }
}
